export const ADD_CHAT_MESSAGE = 'addChatMessage';
export const SET_SOCKET = 'setSocket';
export const SET_SOCKET_STATUS = 'setSocketStatus';
export const ADD_WS_PROVIDER_TO_GLOBAL_STATE = 'addWSProviderToGlobalState';
export const SET_GAME = 'setGame';
export const SET_CURRENT_USER = 'setCurrentUser';
export const INIT_GAME = 'initGame';
export const SET_POPUP = 'setPopup';
export const SET_GAME_SETTINGS = 'setGameSettings';
export const SHOW_CHAT = 'showChat';
export const SET_GAME_TEMP_SETTINGS = 'setGameTemporarySettings';
